var _path, _circle, _path2, _path3, _circle2, _path4, _path5, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeopleMeeting = function SvgPeopleMeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350.3 260.5",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.9 128.3h-8.8V74.8S216.6 60 177 60h-3.8C133.5 60 127 75 127 75v53.3h-8.7a10.2 10.2 0 1 0 0 20.4H232a10.2 10.2 0 0 0 0-20.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175.1,
    cy: 26.3,
    r: 26.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2 222.3H52.5s-30.1 1.6-30.2-33.2v-71.5a11.1 11.1 0 1 0-22.3 0v71.5s-2.7 55.5 52.5 55.5h30.7a11.1 11.1 0 0 0 0-22.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 243.8v-64.9c0-17.6-14.8-16.7-14.8-16.7l-38 1v-52c0-9.7-9.7-13.4-13.4-14.4H50C36.2 99 36 114 36 114v67.7c0 22.2 23.2 23.1 23.2 23.1h46.3v38c0 19.5 20.4 17.6 20.4 17.6 23.2 0 20.4-16.6 20.4-16.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.2,
    cy: 63.1,
    r: 26.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267 222.3h30.8s30 1.6 30.2-33.2v-71.5a11.1 11.1 0 0 1 22.2 0v71.5s2.8 55.5-52.4 55.5H267a11.1 11.1 0 0 1 0-22.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.8 243.8v-64.9c0-17.6 14.9-16.7 14.9-16.7l38 1v-52c0-9.7 9.7-13.4 13.4-14.4h30.2c13.8 2.3 13.8 17.2 13.8 17.2v67.7c0 22.2-23.2 23.1-23.2 23.1h-46.3v38c0 19.5-20.4 17.6-20.4 17.6-23.1 0-20.4-16.6-20.4-16.6z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.1,
    cy: 63.1,
    r: 26.3
  })));
};
export default SvgPeopleMeeting;